import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { DataTableResponse} from '../models/DatatableResponse';
import { AccountService } from './account.service';
import { environment } from '../../environments/environment';
import { Role, UserDto, vwUser } from '../models/User';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  baseUrl = environment.baseUrl;
  public headers = new HttpHeaders();

  constructor(private http: HttpClient, private accountService: AccountService) {

  }

  getDataTableOptions(users){
    const that = this;
    let headers;
    headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', 'Bearer ' + this.accountService.getTokenData());
    // headers = this.headers.set('Authorization', 'Bearer '+ this.accountService.getTokenData());

    let options = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      language : {
        processing : '<div class="sk-spinner sk-spinner-three-bounce"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div> <div class="sk-bounce3"></div> </div>'
      },
      ajax: (dataTablesParameters: any, callback) => {
        that.http.post<DataTableResponse>(this.baseUrl + '/user/List',$.param(dataTablesParameters), {headers: headers})
        	.subscribe(
            resp => {
              users.splice(0, users.length)
              // can't use users=resp.data because we want to pass by reference
              for(let user of resp.data){
                users.push(user)
              }

	            callback({
	              recordsTotal: resp.recordsTotal,
	              recordsFiltered: resp.recordsFiltered,
	              data: []
              });
            },
            error => {
	            callback({
	              recordsTotal: 0,
	              recordsFiltered: 0,
	              data: []
              });
            }
          );
      },
      columns: [{ data: 'id' }, { data: 'firstName' }, { data: 'lastName' }, {data: 'username'}, {data: 'roleName'}, {data: '', orderable: false}]
    }

    return options;
  }

  updateUser(userData){
    return this.http.put<any>(this.baseUrl + '/user/UpdateUser', userData, {});
  }

  updateAsAdminUser(userData){
    return this.http.put<any>(this.baseUrl + '/user/Admin/UpdateUser', userData, {});
  }

  changeOdkPassword(userData){
      return this.http.post<any>(this.baseUrl + '/User/ChangeOdkPassword', userData, {}); 
  }

  overridePassword(userData, isOdkAccount){
    if(isOdkAccount) {
      return this.http.post<any>(this.baseUrl + '/User/OverrideOdkPassword', userData, {});
    } else {
      return this.http.post<any>(this.baseUrl + '/User/OverridePassword', userData, {});
    }
  }

  getRoles(){
    return this.http.get<Role[]>(this.baseUrl + '/role', {headers: this.headers} );
  }

  // TODO this call is being called multiple times and it returns huge data
  getUsersByRole(roleCode){
    return this.http.get<UserDto[]>(this.baseUrl + '/User/' + roleCode + '/getUsers');
  }

  createUser(user){
    return this.http.post<any>(this.baseUrl + '/user/CreateUser', user, {});
  }

  getUser(id){
    const user = this.http.get<UserDto>(this.baseUrl + '/user/' + id);
    return user;
  }

  getUserAsAdmin(id){
    const user = this.http.get<UserDto>(this.baseUrl + '/user/admin/' + id);
    return user;
  }

  deactivateUser(id){
    return this.http.get<any>(this.baseUrl + '/user/activateDeactivate/' + id);
  }

  getUserMenus() {
    return this.http.get<any>(this.baseUrl + '/user/GetUserMenus');
  }

  getInspectors(branchId){
    return this.http.get<UserDto[]>(this.baseUrl + '/User/GetInspectors/' + branchId);
  }
  
  getFilteredApplicants(searchTerm){
    return this.http.get<vwUser[]>(this.baseUrl + '/user/GetFilteredApplicants/' + searchTerm);
  }
}
